// extracted by mini-css-extract-plugin
export default {"root":"SignUpForm_root__5SGJn","check":"SignUpForm_check__R2G2q","link":"SignUpForm_link__ZNFfk"};